<template>
  <!--角色管理 -->
  <div class="videoPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':'0','value':'待审核'},{'key':'1','value':'审核通过'},{'key':'2','value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>所属菜单：</div>
          <el-select v-model="menu" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择所属菜单">
            <el-option
                v-for="item in [{'key':1,'value':'入围产品'},{'key':2,'value':'品牌介绍'},{'key':3,'value':'最终结果'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>新闻标题：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px" v-model="newsTitle"></el-input>
          <el-button @click="searchBtn" type="primary" size="small">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="auditBatchList&&auditBatchList.length" @click="auditBatchBtn" size="small" type="danger">批量审核</el-button>
        </div>

        <el-table
            size="mini"
            tooltip-effect="dark"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column label="新闻标题" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.news_title}}
                </template>
                <span style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.news_title }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="摘要" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.zhaiyao}}
                </template>
                <span style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.zhaiyao }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="封面图" align="center" width="140">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image
                    style="width: 157px; height: 95px"
                    :src="scope.row.img_url"
                    :preview-src-list="scope.row.img_urlList">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="置顶封面图" align="center" width="120">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image v-if="scope.row.top_img_url"
                          style="width: 108px; height: 133px"
                          :src="scope.row.top_img_url"
                          :preview-src-list="scope.row.top_img_urlList">
                </el-image>
                <div v-else>暂无</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="是否登顶" width="80" prop="type" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.is_hot === '0' ? '否' : '是' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="所属菜单" width="80" prop="type" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.menu === 1 ? '入围产品' : scope.row.menu === 2 ? '品牌介绍' : '最终结果' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="新闻类型" width="80" prop="type" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.type === '1' ? '文本' : '视频' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="阅读人数" width="80" prop="watch_count" align="center"></el-table-column>
          <el-table-column header-align="center" width="120" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag v-if="scope.row.examine_status === '0'" type="warning" size="small" effect="dark">审核中</el-tag>
                <el-tag v-if="scope.row.examine_status === '1'" type="success" size="small" effect="dark">审核通过</el-tag>
                <el-tag v-if="scope.row.examine_status === '2'" type="danger" size="small" effect="dark">审核未通过</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="100" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.create_date}}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="权重时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.sortTime}}
                </template>
                {{ scope.row.sortTimeList[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="200"
          >
            <template slot-scope="scope">
              <el-button @click="auditBtn(scope.row)" v-if="scope.row.examine_status === '0'" size="small" type="success">审核</el-button>
              <el-button @click="editBtn(scope.row)" size="small" type="success">修改</el-button>
              <el-button @click="viewBtn(scope.row)" style="margin-top: 10px" size="small" type="success">预览</el-button>
              <el-button @click="viewVideoBtn(scope.row)" style="margin-top: 10px" v-if="scope.row.type === '2'" size="small" type="primary">播放</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <a-modal
        :visible="editDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="修改"
        width="400px"
        @cancel="editCancel"
        @ok="editSubmit('editRuleForm')"
    >
      <el-form
          ref="editRuleForm"
          :model="editRuleForm"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="阅读人数">
          <el-input-number :min="0" v-model="editRuleForm.watchCount"></el-input-number>
        </el-form-item>
        <el-form-item label="排序权重">
          <el-date-picker
              v-model="editRuleForm.sort"
              type="datetime"
              value-format="timestamp"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    审核的弹窗-->
    <a-modal
        :visible="auditDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="审核"
        width="400px"
        @cancel="auditCancel"
        @ok="auditSubmit('auditRuleForm')"
    >
      <el-form
          ref="auditRuleForm"
          :model="auditRuleForm"
          :rules="auditRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="审核状态" prop="examineStatus">
          <el-select v-model="auditRuleForm.examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':'1','value':'审核通过'},{'key':'2','value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>

    <a-modal
        :visible="videoDialogState"
        title="视频"
        width="1200px"
        @cancel="videoDialogCancel"
    >
      <template slot="footer">
        <a-button key="back" v-show="false">
          Return
        </a-button>
        <a-button @click="videoDialogCancel" key="submit" v-show="true">
          关闭
        </a-button>
      </template>
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";

export default {
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      examineStatus:null,
      menu:null,
      newsTitle:null,
      tableData:[],
      totalElements: 0,//数据总数
      multipleSelection:[],
      auditBatchList:[],
      auditDialogState:false,
      auditRuleForm:{
        examineStatus:null
      },
      auditRules:{
        examineStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
      },
      simpleAudit:false,
      auditId:'',
      editDialogState:false,
      editRuleForm:{
        id:'',
        sort: 0,
        watchCount: 0
      },
      videoDialogState:false,
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          //类型
          type: "video/mp4",
          //url地址
          src: ''
        }],
        //你的封面地址
        poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      }
    };
  },
  methods: {
    videoDialogCancel(){
      this.player.pause()
      this.videoDialogState = false
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.menu = null
      this.newsTitle = ''
      this.getList()
    },
    detailsBtn(row){
      this.$router.push({ path: "/details",query:{
          row:row
        }});
    },
    editBtn(row){
      this.editRuleForm.id = row.id
      this.editRuleForm.sort = Number(row.sort)*1000
      this.editRuleForm.watchCount = row.watch_count
      this.editDialogState = true
    },
    viewBtn(row){
      this.$router.push({ path: "/banshouliPreview",query:{
          id:row.id
        }});
    },
    viewVideoBtn(row){
      this.playerOptions.sources[0].src = row.news_content
      console.log(this.playerOptions.sources[0].src)
      this.videoDialogState = true
    },
    auditBtn(row){
      this.simpleAudit = true
      this.auditId = row.id
      this.auditRuleForm.examineStatus = '1'
      this.auditDialogState = true
    },
    auditBatchBtn(){
      this.simpleAudit = false
      this.auditRuleForm.examineStatus = '1'
      this.auditDialogState = true
    },
    auditCancel(){
      this.auditDialogState = false
    },
    editCancel() {
      this.editDialogState = false
    },
    editSubmit(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editRuleForm.sort.toString().length === 13){
            this.editRuleForm.sort = Number(this.editRuleForm.sort)/1000
          }
          this.postAxios("/examine/handNewsInfo/updHandNewsInfoById", this.editRuleForm).then(res=>{
            if (res.success){
              this.$message.success(res.message)
              this.editDialogState = false
              this.getList()
            }
          })
        }
      });
    },
    auditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.simpleAudit){
            this.postAxios("/examine/handNewsInfo/examineHandNewsInfo", {
              examineStatus:this.auditRuleForm.examineStatus,
              ids:[this.auditId]
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditId = ''
                this.auditDialogState = false
                this.getList()
              }
            })
          }else{
            this.postAxios("/examine/handNewsInfo/examineHandNewsInfo", {
              examineStatus:this.auditRuleForm.examineStatus,
              ids:this.auditBatchList
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditBatchList = []
                this.multipleSelection = []
                this.auditDialogState = false
                this.getList()
              }
            })
          }
        }
      });
    },
    //用户列表
    getList() {
      this.postAxios("/examine/handNewsInfo/getAllHandNewsInfo", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          newsTitle:this.newsTitle,
          examineStatus: this.examineStatus === '' ? null : this.examineStatus,
          menu: this.menu === '' ? null : this.menu,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.tableData.forEach((item)=>{
            if (item.sort || item.sort === 0){
              item.sortTime = moment(Number(item.sort)*1000).format('YYYY-MM-DD HH:mm:ss')
              item.sortTimeList = item.sortTime.split(' ')
            }
            item.create_date_list = item.create_date.split(' ')
            item.img_urlList = []
            item.top_img_urlList = []
            if (item.img_url){
              item.img_urlList.push(item.img_url)
            }
            if (item.top_img_url) {
              item.top_img_urlList.push(item.top_img_url)
            }
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.auditBatchList = []
      if (this.multipleSelection&&this.multipleSelection.length){
        this.multipleSelection.forEach((item)=>{
          if (item.examine_status === '0'){
            this.auditBatchList.push(item.id)
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    }
  },
  created() {
    this.getList(); //用户的列表
  }
};
</script>
<style lang="less" scoped>
</style>
